<script>
  import {IMAGES_NEWS, IMAGES} from '@/const/images';
</script>

<style>
  .dash-line {
    border-top: 1px dashed #dbdfe7;
  }
</style>

<div class="df aic jcsb">
  <img width="92" height="18" src={IMAGES.LOGO_DARK_TR} alt="logo" />
  <div class="f1 dash-line" />
  <img width="38" height="38" src={IMAGES_NEWS.TRANSFER_ICON_ARROW} alt="logo" />
  <div class="f1 dash-line" />
  <img width="80" height="18" src={IMAGES.LOGO_DARK} alt="logo" />
</div>
